import { z } from "zod";
import { D2CAgentId, getMaxDate } from "../utils";

export const buildPrimaryInformationSchema = (agentId?: number) => {
  return z.object({
    firstName: z
      .string()
      .min(2, { message: "First Name must be at least 2 characters" })
      .max(30, { message: "First Name must be less than 30 characters" }),
    lastName: z
      .string()
      .min(2, { message: "Last Name must be at least 2 characters" })
      .max(30, { message: "Last Name must be less than 30 characters" }),
    birthDate: z
      .date({ required_error: "Birth Date is required" })
      .refine((val) => val <= new Date(), { message: "Birth Date cannot be in the future" }),
    address: z
      .string({ required_error: "Address must be at least 4 characters" })
      .min(4, { message: "Address must be at least 4 characters" })
      .max(40, { message: "Address must be less than 30 characters" })
      .refine((value) => /[0-9 a-zA-Z]/.test(value), "Invalid Address"),
    addressTwo: z
      .string()
      .optional(),
    phone: z
      .string()
      .length(12, { message: "Phone Number must be at 10 digits" })
      .refine(
        (value) =>
          /^(?!000-000-0000|111-111-1111)((\d{3}-\d{3}-\d{4})|(\(\d{3}\) \d{3}-\d{4})|(\d{10}))$/.test(
            value
          ),
        "Invalid Phone Number"
      ),
    gender: z.enum(["M", "F"], {
      errorMap: () => ({ message: "Please select a Gender" }),
    }),
    city: z
      .string()
      .min(2, { message: "City must be at least 2 characters" })
      .max(30, { message: "City must be less than 30 characters" }),
    email: z
      .string()
      .email()
      .or(z.literal(""))
      .refine(
        //@ts-ignore
        (value) => {
          if (agentId === D2CAgentId) {
            // If agentID is 660555, email is required
            return value !== "";
          }
          // For all other agentIDs, email is not required
          return true;
        }
      ),
    billingAddress: z
      .string()
      .min(4)
      .max(40)
      .refine((value) => /[0-9 a-zA-Z]/.test(value), "Invalid Address")
      .optional()
      .or(z.literal("")),
    billingCity: z.string().min(2).max(20).optional().or(z.literal("")),
    billingState: z.string().min(2).max(15).optional().or(z.literal("")),
  })
};

// Not in use by the primaryInformation form
// this will validate the data contained within Member
export const buildMemberSchema = (agentId?: number) => {
  return z.object({
    firstName: z
      .string()
      .min(2, { message: "First Name must be at least 2 characters" })
      .max(30, { message: "First Name must be less than 30 characters" }),
    lastName: z
      .string()
      .min(2, { message: "Last Name must be at least 2 characters" })
      .max(30, { message: "Last Name must be less than 30 characters" }),
    dateOfBirth: z
      .string({ required_error: "Date of Birth is required" })
      .transform((val: string) => new Date(val))
      .refine((val) => val <= new Date(), { message: "Birth Date cannot be in the future" })
      .refine((val) => val <= new Date(getMaxDate()), { message: "Member must be at least 18 years old" }),
    address1: z
      .string({ required_error: "Address1 must be at least 4 characters" })
      .min(4, { message: "Address must be at least 4 characters" })
      .max(40, { message: "Address must be less than 30 characters" })
      .refine((value) => /[0-9 a-zA-Z]/.test(value), "Invalid Address"),
    address2: z
      .string()
      .optional(),
    phone1: z
      .string()
      .length(12, { message: "Phone Number must be at 10 digits" })
      .refine(val => !val, 'phone1 is required')
      .refine(
        (value) =>
          /^(?!000-000-0000|111-111-1111)((\d{3}-\d{3}-\d{4})|(\(\d{3}\) \d{3}-\d{4})|(\d{10}))$/.test(
            value
          ),
        "Invalid Phone Number"
      ),
    gender: z.enum(["M", "F"], {
      errorMap: () => ({ message: "Please select a Gender" }),
    }),
    city: z
      .string()
      .min(2, { message: "City must be at least 2 characters" })
      .max(30, { message: "City must be less than 30 characters" }),
    email: z
      .string()
      .email()
      .or(z.literal(""))
      .refine(
        //@ts-ignore
        (value) => {
          if (agentId === D2CAgentId) {
            // If agentID is 660555, email is required
            return value !== "";
          }
          // For all other agentIDs, email is not required
          return true;
        }
      ),
    billingAddress: z
      .string()
      .min(4)
      .max(40)
      .refine((value) => /[0-9 a-zA-Z]/.test(value), "Invalid Address")
      .optional()
      .or(z.literal("")),
    billingCity: z.string().min(2).max(20).optional().or(z.literal("")),
    billingState: z.string().min(2).max(15).optional().or(z.literal("")),
  })
};